<div class="meal-detail-container">
  <app-loading *ngIf="showLoading"></app-loading>
  <div class="meal-detail-nav-bar box">
    <div class="meal-detail-nav-bar-title">{{ title }}</div>
    <div class="meal-detail-back img-holder" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div *ngIf="dataIsReady" class="meal-detail-holder box">
    <div
      *ngIf="dayStatus === 'diet' || dayStatus === 'cheatDay'"
      class="meal-detail-suggested-meal"
      [ngStyle]="{
        height: lockPlan ? '312px' : 'auto',
        padding: lockPlan ? '0' : '16px 0',
        'min-height': status === 1 && dayStatus !== 'cheatDay' ? '216px' : '0'
      }"
      id="package-box"
    >
      <div *ngIf="lockPlan" class="meal-detail-meal-cell-lock">
        <img src="assets/plan/lock.svg" />
        <div class="meal-detail-meal-cell-lock-shop" (click)="goToShop()">
          برای امروز اشتراک نداری
        </div>
      </div>
      <div
        class="meal-detail-meal-cell-title"
        [ngStyle]="{ padding: lockPlan ? '16px 0' : '0' }"
      >
        پکیج پیشنهادی
      </div>
      <div
        *ngIf="!lockPlan && (status !== 1 || dayStatus === 'cheatDay')"
        class="meal-detail-meal-cell-calorie"
      >
        {{ calorieCalculator.calculateMealCalorie(planShared.selectedMeal) }}
        کالری
      </div>
      <div *ngIf="!lockPlan">
        <div
          *ngFor="let food of planShared.selectedMeal.foods; let i = index"
          class="meal-detail-meal-cell-food"
        >
          <div class="meal-detail-meal-cell-food-name">
            {{ food.foodModel.name }}
          </div>
          <div class="meal-detail-meal-cell-food-amount">
            {{ planService.getFoodAmounts(food) }}
          </div>
        </div>
        <div class="meal-detail-meal-cell-buttons">
          <div
            *ngIf="dayStatus === 'cheatDay'"
            class="meal-detail-meal-cell-cheatday"
            (click)="goToCheatDay()"
          >
            <div class="meal-detail-meal-cell-cheatday-holder">
              <img
                class="meal-detail-meal-cell-cheatday-img"
                src="assets/plan/cheatdayEmoji.svg"
              />
              <div class="meal-detail-meal-cell-cheatday-title">روز آزاد</div>
            </div>
          </div>
          <div
            *ngIf="status !== 1 && dayStatus !== 'cheatDay'"
            class="meal-detail-meal-cell-add-package"
            (click)="consumed(true)"
            id="consume-meal-box"
          >
            <div class="meal-detail-meal-cell-add-package-box">
              <img
                class="meal-detail-meal-cell-add-package-img"
                src="assets/plan/plus-white.svg"
              />
              <div class="meal-detail-meal-cell-add-package-title">
                افزودن پکیج
              </div>
            </div>
          </div>
          <div
            *ngIf="status !== 1 && dayStatus !== 'cheatDay'"
            class="meal-detail-meal-cell-change-package"
            (click)="changePackage()"
            id="change-meal-box"
          >
            <img
              class="meal-detail-meal-cell-change-package-img"
              src="assets/plan/change.png"
            />
            <div class="meal-detail-meal-cell-change-package-title">
              تعویض پکیج
            </div>
          </div>
          <div
            *ngIf="status === 1 && dayStatus !== 'cheatDay'"
            class="meal-detail-meal-cell-consumed-holder"
          ></div>
        </div>
        <div
          *ngIf="status === 1 && dayStatus !== 'cheatDay'"
          class="meal-detail-meal-cell-consumed"
        >
          <div class="meal-detail-meal-cell-calorie">
            {{
              calorieCalculator.calculateMealCalorie(planShared.selectedMeal)
            }}
            کالری
          </div>
          <img
            class="meal-detail-meal-cell-consumed-img"
            src="assets/plan/check.svg"
          />
          <div
            class="meal-detail-meal-cell-consumed-change"
            (click)="pendingDialog()"
          >
            تغییر
          </div>
        </div>
      </div>
    </div>
    <app-plan-status
      *ngIf="dayStatus === 'generate'"
      [dataIsReady]="dataIsReady"
      [input]="planStatusInput"
    ></app-plan-status>
    <div
      class="meal-detail-title box"
      [ngStyle]="{
        'margin-top':
          dayStatus === 'cheatDay' || dayStatus === 'generate'
            ? '32px'
            : dayStatus === 'diet'
            ? '16px'
            : '0'
      }"
    >
      غذاهای ثبت شده
    </div>
    <div
      *ngFor="let food of foods; let i = index"
      name="food-box"
      class="food-cell box"
      (click)="openFoodEdit(food)"
    >
      <div *ngIf="food.title && food.calorie">
        <div class="food-cell-title">{{ food.title }}</div>
        <div class="food-cell-description">{{ foodsAmount[i] }}</div>

        <img class="food-cell-more-icon" src="assets/general/left-gray.svg" />
      </div>
      <div *ngIf="!food.title && !food.calorie">
        <div class="food-cell-title">{{ food.foodModel.name }}</div>
        <div class="food-cell-description">{{ foodsAmount[i] }}</div>
        <img class="food-cell-more-icon" src="assets/general/left-gray.svg" />
      </div>
    </div>
    <div *ngIf="foods.length === 0" class="meal-detail-no-food">
      غذایی برای این وعده انتخاب نکردید.
    </div>
    <div class="meal-detail-add-holder box" id="add-food-box">
      <img class="meal-detail-add-button-img" src="assets/plan/plus.svg" />
      <div class="meal-detail-add-button" (click)="addFood()">
        افزودن غذای جدید
      </div>
    </div>
    <div class="meal-fact-title box">جدول ارزش غذایی</div>
    <div *ngFor="let foodFact of foodFactsNamesBreif; let i = index">
      <div *ngIf="foodFactsAmount[i] !== -1" class="food-fact-cell box">
        <div class="food-fact-cell-title">{{ foodFact }}</div>
        <div class="food-fact-cell-unit-holder">
          <!-- <div *ngIf="littleCalorie !== 0 && i == 0" class="food-fact-cell-calorie">{{littleCalorie.toFixed(0)}}</div> -->
          <!-- <img *ngIf="littleCalorie !== 0 && i == 0" class="food-fact-cell-calorie-img" src="assets/plan/down-arrow.svg"> -->
          <div
            *ngIf="muchCalorie !== 0 && i === 0 && dayStatus !== 'cheatDay'"
            class="food-fact-cell-calorie"
          >
            {{ muchCalorie.toFixed(0) }}
          </div>
          <img
            *ngIf="muchCalorie !== 0 && i === 0 && dayStatus !== 'cheatDay'"
            class="food-fact-cell-calorie-img"
            src="assets/plan/up-arrow.svg"
          />
          <div class="food-fact-cell-amount">
            {{ addZeroes(foodFactsAmount[i].toString()) }}
          </div>
          <div class="food-fact-cell-unit">{{ foodFactsUnits[i] }}</div>
        </div>
      </div>
    </div>
    <div *ngIf="!morefoodFacts" class="food-fact-more-box box">
      <div class="food-fact-more" (click)="showMoreFoodFacts()">نمایش همه</div>
      <!-- <div *ngIf="morefoodFacts" class="food-fact-more" (click)="showLessFoodFacts();">نمایش کمتر</div> -->
    </div>
  </div>
  <app-bottomsheet
    *ngIf="showFoodFactDetail"
    [type]="'foodFact'"
  ></app-bottomsheet>
  <app-tutorial *ngIf="showTutorial" [input]="tutorialInput"></app-tutorial>
  <app-ios-bottomsheet
    *ngIf="showIosBottomsheet"
    [input]="iosBottomsheetInput"
  ></app-ios-bottomsheet>
  <app-plan-overview-bottomsheet
    *ngIf="planBottomSheet"
    [show]="showplanBottomSheet"
  ></app-plan-overview-bottomsheet>
</div>
